/*
  Attempted to convert to *.ts but encountered an error:
  Component selectors can only be used in conjunction with @emotion/babel-plugin.
*/
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { breakpoints, Button, colors } from '../../nextgen/plushcare-components';

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const optionStyles = (props) => css`
  display: flex;
  align-items: center;
  width: 100%;
  border: ${props.isSelected ? `2px solid ${props.theme.colors.foreground}` : `1px solid ${colors.gray}`};
  border-radius: 4px;
  padding: 13px 16px;
  position: relative;
  margin-bottom: 8px;
`;

export const Option = styled.div`
  ${props => optionStyles(props)};
`;

export const radioInputStyles = (props) => css`
  -webkit-appearance: none;
  position: relative;
  width: 22px;
  height: 22px;
  padding: 0;
  border: 4px solid ${colors.white};
  border-radius: 12px;
  margin-bottom: 0;
  background: ${colors.white};
  flex-shrink: 0;

  &::before {
    content: '';
    position: absolute;
    top: -5px;
    left: -5px;
    display: block;
    width: 24px;
    height: 24px;
    border: 2px solid ${props.theme.colors.foreground};
    border-radius: 24px;
  }

  &:checked {
    background: ${props.theme.colors.foreground};
  }

  &:focus {
    outline: none;
  }

  &:focus::before {
    box-shadow: 0 0 5px;
  }
`;

export const RadioTile = styled.div`
  display: flex;
  flex: 1 0 auto;
  width: 100%;
  align-items: center;

  input[type=radio] {
    ${props => radioInputStyles(props)};
  }
`;

export const radioTileLabelStyles = css`
  margin: 3px 0 0 15px;
  cursor: pointer;
  display: flex;
  width: 100%;
  align-items: center;
`;

export const RadioTileLabel = styled.label`
  ${radioTileLabelStyles};
`;

export const RadioTileLabelText = styled.span`
  display: flex;
  width: calc(100% - 30px);
  flex-wrap: wrap;
`;

export const RadioTileLabelName = styled.span`
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  color: ${colors.black};
  flex-wrap: wrap;
`;

export const RadioTileSubText = styled.span`
  color: ${colors.support};
  font-size: 16px;
  line-height: 18px;
`;

export const ContinueBtn = styled(Button)`
  font-size: 20px;
  justify-self: center;
  margin-top: 16px;
  margin-bottom: 25px;
  width: 100%;

  @media (min-width: ${breakpoints.mobile}) {
    width: auto;
    padding-left: 40px;
    padding-right: 40px;
  }
`;

export const ActionsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 0;
  width: 100%;
  font-size: 16px;
  line-height: 18px;
  color: ${colors.darkGray};
  padding: 0 0.75rem;
  // styles for putting CTAs at the bottom of the page for mobile devices
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translate(-50%, 0);
  max-width: 370px;

  @media (min-width: ${breakpoints.tablet}) {
    margin: 80px auto 0;
    position: relative;
    left: 0;
    transform: none;
    bottom: 0;
    padding: 0;
  }

  @media (min-width: ${breakpoints.mobile}) {
    margin-top: 90px;
    position: relative;
    padding: 0;
    max-width: 100%;
  }
`;
